import React, { PropTypes } from 'react';


const CoverCell = ({cover, href, size}) => {

    let cover_s = cover && cover['S'] ? cover['S'].cover_url : '';
    let cover_m = cover && cover['M'] ? cover['M'].cover_url : '';
    // per default both sizes
    if (! size){
        size='B';
    }
    return (
        <div style={{textAlign: 'center', marginRight: 10}}>
                {size === 'B' && (
                    <a href={href}>
                        <span className="media-object visible-xs cover-s">            
                            <img  src={cover_s} />
                        </span>
                        <span className="media-object hidden-xs cover-m">
                            <img  src={cover_m} />
                        </span>
                    </a>
                    )
                }
                {size === 'S' && (
                    <a href={href}  className="media-object cover-s">
                            <img  src={cover_s} />
                    </a>
                    )
                }
                {size === 'M' && (
                    <a href={href} className="media-object cover-m">
                        <img src={cover_m} />
                    </a>
                    )
                }
        </div>
        )
}


CoverCell.propTypes = {
    cover: PropTypes.shape({
        'S' : PropTypes.shape({
            'cover_url' : PropTypes.string
        }),
        'M' : PropTypes.shape({
            'cover_url' : PropTypes.string
        }),
        'L' : PropTypes.shape({
            'cover_url' : PropTypes.string
        })
    }).isRequired,
    href: PropTypes.string
}

export default CoverCell;



// WEBPACK FOOTER //
// ./shared/covercell.js